exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".modal-body{font-family:Roboto,sans-serif;padding-bottom:0}.modal-body .row{margin-bottom:5px}.modal-body .row label{padding-top:7px}.modal-body .modal-footer{margin-top:10px;padding-bottom:0}.modal-content{border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./client/app/app.modal.less
// module id = 1895
// module chunks = 0